import { render, staticRenderFns } from "./timeLhc.vue?vue&type=template&id=235ac2a6"
import script from "./timeLhc.vue?vue&type=script&lang=js"
export * from "./timeLhc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports